import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import enCommon from '../locales/en/common.json'
import enLorem from '../locales/en/lorem.json'

export const SUPPORTED_LOCALES = ['en'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]
export const DEFAULT_LOCALE: SupportedLocale = 'en'

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    ns: ['common', 'lorem'],
    defaultNS: 'common',
    resources: {
      en: { common: enCommon, lorem: enLorem },
    },
    interpolation: { escapeValue: false },
    returnNull: false,
    // Required so parseMissingKeyHandler receives `<ns>:<key>` instead of just `<key>` —
    // matches the test contract where missing keys fall back to their fully-qualified name.
    appendNamespaceToMissingKey: true,
    parseMissingKeyHandler: (key) => key,
  })

export default i18n
